<template>
  <v-row class="pb-5" v-if="showInfo">
    <v-col cols="12" sm="4">
      <p class="gray--text font-weight-bold quotation-title">
        DADOS
      </p>
    </v-col>
    <v-spacer />
    <v-col
      cols="12"
      sm="4"
      lg="3"
      class="pr-sm-12 pr-5 pb-5 pb-sm-0 text-sm-end"
    >
      <p class="body-2 primary--text mb-0">
        Número de Solicitação
        <v-tooltip bottom content-class="tooltip-label-form">
          <template v-slot:activator="{ on }">
            <v-icon color="secondary" size="10" v-on="on">
              fa-info-circle
            </v-icon>
          </template>
          <v-row>
            <v-col cols="12" class="px-4 py-3">
              <p class="white--text tooltip-label-text mb-0">
                Este é o identificador único da sua solicitação. Utilize-o para
                encontrar sua cotação, acompanhar a evolução e comunicar com
                outras pessoas.
              </p>
            </v-col>
          </v-row>
        </v-tooltip>
      </p>
      <div class="text-md-end">
        <p class="secondary--text font-weight-bold mb-0">
          {{ info.numero }}
        </p>
      </div>
    </v-col>
    <v-col
      cols="12"
      sm="4"
      lg="3"
      class="pr-sm-0 pr-5 pb-5 pb-sm-0 text-sm-end"
    >
      <p class="body-2 primary--text mb-0">
        Número do Processo Judicial
        <v-tooltip bottom content-class="tooltip-label-form">
          <template v-slot:activator="{ on }">
            <v-icon color="secondary" size="10" v-on="on">
              fa-info-circle
            </v-icon>
          </template>
          <v-row>
            <v-col cols="12" class="px-4 py-3">
              <p class="white--text tooltip-label-text mb-0">
                Identificador único de processos que possibilita a localização
                dos mesmos. Possui o seguinte formato: NNNNNNN-DD.
                AAAA.J.TR.OOOO.
              </p>
            </v-col>
          </v-row>
        </v-tooltip>
      </p>
      <div class="text-md-end">
        <p class="secondary--text font-weight-bold mb-0">
          {{ numberProcess }}
        </p>
      </div>
    </v-col>
  </v-row>
</template>
<script>
export default {
  computed: {
    numberProcess() {
      return this.info.processo?.numero_processo || "---";
    }
  },
  props: {
    info: {
      type: Object
    },
    showInfo: {
      type: Boolean,
      default: true
    }
  }
};
</script>
